import Customer from "pages/Customer/Customer"
import CustomerForm from "pages/Customer/CustomerForm"
import CustomerCard from "pages/CustomerCard/CustomerCard"
import CustomerCardForm from "pages/CustomerCard/CustomerCardForm"
import Transaction from "pages/Transaction/Transaction"
import Login from "pages/Login"
import Bank from "pages/Setting/Bank/Bank"
import BankForm from "pages/Setting/Bank/BankForm"
import CardVendor from "pages/Setting/CardVendor/CardVendor"
import EDC from "pages/Setting/EDC/EDC"
import EDCForm from "pages/Setting/EDC/EDCForm"
import Setting from "pages/Setting/Setting"
import User from "pages/Setting/User/User"
import UserForm from "pages/Setting/User/UserForm"
import TransactionReport from "pages/TransactionReport/TransactionReport"
import DailyTransactionReport from "pages/DailyTransactionReport/DailyTransactionReport"
import StatisticReport from "pages/StatisticReport/StatisticReport"
import PaymentReceived from "pages/PaymentReceived/PaymentReceived"
import Reseller from "pages/Reseller/Reseller"
import EdcLocation from "pages/EdcLocation/EdcLocation"
import BeneficiaryAccount from "pages/BeneficiaryAccount/BeneficiaryAccount"
import BeneficiaryAccountForm from "pages/BeneficiaryAccount/BeneficiaryAccountForm"
import CustomerExeption from "pages/Setting/CustomerExeption/CustomerExeption"
import TransactionReportForm from "pages/TransactionReport/TransactionReportForm"
import Location from "pages/Setting/Location/Location"
import LocationForm from "pages/Setting/Location/LocationForm"
import LocationAccess from "pages/Setting/LocationAccess/LocationAccess"
import Dashboard from "pages/Dashboard/Dashboard"
import TransferSource from "pages/Setting/TransferSource/TransferSource"
import TransferSourceFormModal from "pages/Setting/TransferSource/TransferSourceFormModal"
import Transfer from "pages/Transfer/Transfer"
import CashIn from "pages/CashIn/CashIn"
import CashInForm from "pages/CashIn/CashInForm"
import TransferPL from "pages/TransferPL/TransferPL"
import TransferPLForm from "pages/TransferPL/TransferPLForm"
import Pelunasan from "pages/Pelunasan/Pelunasan"
import PelunasanForm from "pages/Pelunasan/PelunasanForm"
import PrimaryBankBalance from "pages/Setting/PrimaryBankBalance/PrimaryBankBalance"
import TransferHistory from "pages/Transfer/TransferHistory"
import Expense from "pages/Expense/Expense"
import ExpenseForm from "pages/Expense/ExpenseForm"
import CustomerView from "pages/Customer/CustomerView"

import { Outlet } from "react-router-dom";
import MainContainer from "components/layout/MainContainer"
import FrequentCustomer from "pages/Setting/FrequentCustomer/FrequentCustomer"


export const routes = [{
   element: <MainContainer />,
children:[
   {
      path: "/login",
      element: <Login />
   },
   {
      path: "/",
      element: <Transaction />
   },
   {
      path: "/pelunasan",
      element: <Pelunasan />
   },
   {
      path: "/pelunasan/form",
      element: <PelunasanForm />
   },
   
   {
      path: "/customer",
      element: <Customer />
   },
   {
      path: "/customer/form",
      element: <CustomerForm />
   },
   {
      path: "/customer/view",
      element: <CustomerView />
   },
   {
      path: "/customer-card",
      element: <CustomerCard />
   },
   {
      path: "/customer-card/form",
      element: <CustomerCardForm />
   },

   {
      path: "/setting",
      element: <Setting />
   },
   {
      path: "/setting/bank",
      element: <Bank />
   },
   {
      path: "/setting/bank/form",
      element: <BankForm />
   },
   {
      path: "/setting/edc",
      element: <EDC />
   },
   {
      path: "/setting/edc/form",
      element: <EDCForm />
   },
   {
      path: "/beneficiary-account",
      element: <BeneficiaryAccount />
   },
   {
      path: "/beneficiary-account/form",
      element: <BeneficiaryAccountForm />
   },
   {
      path: "/setting/card-vendor",
      element: <CardVendor />
   },
   {
      path: "/setting/user",
      element: <User />
   },
   {
      path: "/setting/user/form",
      element: <UserForm />
   },
   {
      path: "/transaction-report",
      element: <TransactionReport />
   },
   {
      path: "/transaction-report/form",
      element: <TransactionReportForm />
   },
   {
      path: "/daily-transaction-report",
      element: <DailyTransactionReport />
   },
   {
      path: "/statistic-report",
      element: <StatisticReport />
   },
   {
      path: "/payment-received",
      element: <PaymentReceived />
   },
   {
      path: "/setting/reseller",
      element: <Reseller />
   },
   {
      path: "/setting/customer-exeption",
      element: <CustomerExeption />
   },
   {
      path: "/setting/primary-bank-balance",
      element: <PrimaryBankBalance />
   },
   {
      path: "/setting/location",
      element: <Location />
   },
   {
      path: "/setting/location/form",
      element: <LocationForm />
   },
   {
      path: "/setting/user/location-access",
      element: <LocationAccess />
   },
   {
      path: "/dashboard",
      element: <Dashboard />
   },

   // SETTINGS
   {
      path: "/setting/transfer-source",
      element: <TransferSource />
   },   
   {
      path: "/setting/transfer-source/form",
      element: <TransferSourceFormModal />
   },
   {
      path: "/setting/frequent-customer",
      element: <FrequentCustomer />
   },   

   {
      path: "/transfer",
      element: <Transfer />
   },
   {
      path: "/transfer/transfer-history",
      element: <TransferHistory />
   },


   {
      path: "/expense",
      element: <Expense />
   },
   {
      path: "/expense/form",
      element: <ExpenseForm />
   },

   
   {
      path: "/cash-in",
      element: <CashIn />
   },
   
   {
      path: "/cash-in/form",
      element: <CashInForm />
   },
   {
      path: "/transfer-pl",
      element: <TransferPL />
   },
   
   {
      path: "/transfer-pl/form",
      element: <TransferPLForm />
   },
   // {
   //    path: "/",
   //    element: <Home />
   // },
]
   
}]
 

export const ROLE_ADMIN = "admin"
export const ROLE_OWNER = "owner"